import useEntity from "../../hooks/useTimberStorage";
import TimberStorageDetail from "../../components/timberStorage/TimberStorageDetail/TimberStorageDetail";
import TimberStorageScoped from "../../components/timberStorage/TimberStorageDetail/TimberStorageScoped";
import TimberStorageTabs from "../../components/timberStorage/TimberStorageDetail/TimberStorageTabs";
import { useGetTimberStorageQuery } from "../../apis/TimberStorage.api";
import { PrimaryTimberStorage } from "../../types/models/TimberStorage";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import {cuttingStateEditCheck} from "../../stateChecks.ts";
import {useGetCuttingQuery} from "../../apis/Cutting.api";
import {PrimaryCutting} from "../../types/models/Cutting";

const TimberStorageDetailPage = () => {

    useTitle(t`Details Timber Storage`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { timberStorageId: id } = useParams();

    const { data, refetch } = useGetTimberStorageQuery(PrimaryTimberStorage.fromPath(id))
    const { deleteTimberStorage } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteTimberStorage(data, '..')
    }, [data, deleteTimberStorage])

    const { data: cutting } = useGetCuttingQuery(PrimaryCutting.fromId(data?.cuttingId), {skip: !data?.cuttingId})

    if (id === 'scoped') {
        return (<TimberStorageScoped/>)
    }

    return (
        <Box data-testid="TimberStorage-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <TimberStorageDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/TimberStorages/update/view'
        ) ||
false) &&
                        cuttingStateEditCheck(cutting?.state)
                        &&
                        <Button size="small" variant="outlined" data-testid="TimberStorage-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/TimberStorages/delete/view'
        ) ||
false) &&
                        cuttingStateEditCheck(cutting?.state)
                        &&
                        <Button size="small" color="error" variant="outlined" data-testid="TimberStorage-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <TimberStorageTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default TimberStorageDetailPage;
